import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from "notistack";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Tooltip } from '@material-ui/core';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import {DropzoneArea} from 'material-ui-dropzone';
import {DeletePopUp,EmptyCollection,PageLoader} from '../../../shared_elements';
import { globalDeleteService, globalGetService, globalPostService ,globalPutService,globalExportService} from "../../../utils_v2/globalApiServices";
import { checkApiStatus, getLocalStorageInfo ,onCheckFormPermission,downloadFileType} from "../../../utils_v2";
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { Visibility } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
const Attachment = ({params,currentFormDetail,getCurrentFormDetail}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false);
    const [uploadAttachment, setUploadAttachment] = useState({modal:false, files:[]})
    const [attachments, setAttachments] = useState([]);
    const [deleteAttachment, setDeleteAttachment] = useState({modal:false, attachment:null});
    const [preview, setPreview] = useState({modal:false,data:null});
    useEffect(() => {
         getAttachments({});  
    }, []);
    const getAttachments = () => {
        globalGetService(`technical/workorder/${params.workOrderSlug}/gap-report/${params.id}/?asset_type=${params.type}`)
        .then(response => {
            if(checkApiStatus(response)){
                setAttachments(response.data.data.files)
            }
        })
    }
    const onDeleteAttachment = () => {
        setLoading(true)
        globalDeleteService(`technical/workorder/${params.workOrderSlug}/gap-report/${params.id}/file/${deleteAttachment.attachment.id}/?asset_type=${params.type}`)
        .then(response => {
            setLoading(false)
            if(checkApiStatus(response)){
                enqueueSnackbar(response.data.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }});
                setDeleteAttachment({modal:false, attachment:null});
                setAttachments(attachments.filter((item) => item.id !== deleteAttachment.attachment.id))
                getCurrentFormDetail()
            }else{
                enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }});
            }
        })
    }
    const onUploadAttachment = () => {
        if(uploadAttachment.files.length === 0){
            enqueueSnackbar("Please upload Attachment ", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }});
        }else{
            setLoading(true)
            let formData = new FormData();
            for(let i=0; i<uploadAttachment.files.length;i++){
                formData.append("files", uploadAttachment.files[i])
            }
              globalPutService(`technical/workorder/${params.workOrderSlug}/gap-report/${params.id}/?asset_type=${params.type}`,formData)
            .then(response => {
                setLoading(false)
                if(checkApiStatus(response)){
                    enqueueSnackbar(response.data.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }});
                    setUploadAttachment({modal:false, files:[]});
                     setAttachments(response.data.data.files);
                     getCurrentFormDetail()
                }else{
                    enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }});
                }
            })
        }
        
    }

    const onDownloadAttachment = (item) =>{
        setLoading(true)
        globalExportService(`technical/workorder/${params.workOrderSlug}/gap-report/${params.id}/file-download/${item.id}/?asset_type=${params.type}`)
        .then(response => {
            setLoading(false)
            downloadFileType(response, item.name.split('.').slice(0, -1).join('.'), `.${item.name.split('.').pop()}`);
          })
    }

    return(
        <div className='task-management-attachments'>
        <Paper style={{padding:'4px', marginBottom:'4px'}}>    
            <ul className='list-inline attachment-blk'>
                {attachments.length > 0 &&  attachments.map((item) => {
                    const extension = item?.name?.split('.')?.pop()?.toLowerCase();
                    return(
                        <li className='attachment-list list-inline-item' style={{width:'160px'}}>
                            <Paper style={{ marginBottom:'4px', padding:"4px" }}>
                            {['jpg', 'jpeg', 'png', 'gif'].includes(extension) ?
                                <div className='attachment' style={{justifySelf:'center'}}>
                                    <img style={{width:'150px', height:'120px', border:'groove 1px'}} src={item.file} alt={item.name} />
                                </div>:
                                <div className='attachment' style={{width:'150px', height:'120px', border:'groove 1px', textAlign:'center', alignContent:'center'}}>
                                    <span className='extension'>{extension?.toUpperCase()}</span>
                                </div>
                            }
                            <div className='file-info '>
                                <span>{item?.name?.length > 15 ? item?.name?.slice(0,15)+'...' : item?.name?.length}</span>
                                <ul className='list-inline flex-centered'>
                                    <li className='list-inline-item'>
                                        <SaveAltIcon onClick={() => onDownloadAttachment(item)} download={item.name}  color='primary' fontSize='small' style={{cursor:'pointer', fontSize: '1.15rem'}} />
                                    </li>
                                    {onCheckFormPermission(currentFormDetail) ? item.created_by &&  item.created_by.id ?
                                        getLocalStorageInfo().user.id === item.created_by.id ?
                                        <li className='list-inline-item'>
                                            <Tooltip title='Delete' arrow><DeleteOutlineIcon onClick={() => setDeleteAttachment({modal:true, attachment:item})} color='secondary' fontSize='small' style={{cursor:'pointer'}} /></Tooltip>
                                        </li>:null:
                                        <li className='list-inline-item'>
                                            <Tooltip title='Delete' arrow><DeleteOutlineIcon onClick={() => setDeleteAttachment({modal:true, attachment:item})} color='secondary' fontSize='small' style={{cursor:'pointer'}} /></Tooltip>
                                        </li>
                                   : null }
                                   <li className='list-inline-item'>
                                    <Visibility fontSize='small' color='primary' onClick={()=>setPreview({modal:true,data:item})} />
                                   </li>
                                </ul>
                            </div>
                            </Paper>
                        </li>
                    )
                })}
                { attachments.length == 0 ? <EmptyCollection title={'No attactments found'}/> : null}
            </ul>
            {onCheckFormPermission(currentFormDetail) ?
             <div>
                <Button onClick={() => setUploadAttachment({modal:true, files:[]})} color='primary' variant='outlined' size='small'><AddIcon color='primary' style={{ fontSize: '1.15rem' }} />Add Attachment</Button>
            </div>  : null}
        </Paper>
            { deleteAttachment.modal ? (
                <DeletePopUp
                    modal={deleteAttachment.modal}
                    toggleModalFn={() => setDeleteAttachment({modal:false, attachment:null})}
                    title="Delete Attachment"
                    content={<h4>Are you sure you want to delete?</h4>}
                    deleteRecordFn={() => onDeleteAttachment()}
                    confirmText="Delete"
                />
            ) : null}  
            { uploadAttachment.modal ?
                <Dialog
                    open={uploadAttachment.modal}
                    onClose={() => setUploadAttachment({modal:false, files:[]})}
                >
                    <DialogTitle id="scroll-dialog-title">
                        Upload Attachment(s)
                    </DialogTitle>
                    <DialogContent dividers={true}>
                        <div style={{minWidth:'400px'}}>
                            <DropzoneArea
                                filesLimit={10}
                                maxFileSize={131072000}
                                showPreviewsInDropzone={false}
                                useChipsForPreview={true}
                                showPreviews={ true }
                                dropzoneText={<p>Drag & Drop Documents<br/> OR <br/> Click Here<br/> </p>}
                                dropzoneClass="drag-drop-cnt"
                                maxWidth="sm"
                                showAlerts={['info', 'error']}
                                alertSnackbarProps={{anchorOrigin: {vertical:'top', horizontal:'right'}}}
                                clearOnUnmount={true}
                                onChange={(files) => setUploadAttachment({...uploadAttachment, files:files})}
                            />
                        </div>
                        <span> <p className='attachment-note'>Note:- Maximum Of 10 files can be uploded </p> </span>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={isLoading} onClick={() => setUploadAttachment({modal:false, files:[]})} color="primary" variant='outlined' size='small'>Cancel</Button>
                        <Button disabled={isLoading || !uploadAttachment.files.length} onClick={onUploadAttachment} color="primary" variant='contained' size='small'>
                            {isLoading ? <CircularProgress size={20} /> : 'Upload'}
                        </Button>
                    </DialogActions>
                </Dialog>:null
            }
            {isLoading ? <PageLoader /> : null}
            {preview.modal && (
                <Dialog open={preview.modal} fullScreen >
                    <DialogTitle>Attachment Preview</DialogTitle>
                    <DialogContent dividers style={{ textAlign: 'center' }}>
                        {preview?.data?.name?.endsWith('.xlsx') || preview?.data?.name?.endsWith('.xlsm') || preview.data?.name?.endsWith('.xls') || preview?.data?.name?.endsWith('.doc') || preview?.data?.name?.endsWith('.docx') ? (
                            <iframe src={'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(preview?.data?.file)} width='100%' height={window.innerHeight} frameborder='0'></iframe>

                        ) : preview?.data?.name?.endsWith('.jpeg') || preview?.data?.name?.endsWith('.jpg') || preview?.data?.name?.endsWith('.png') ? (
                            <img src={preview?.data?.file} alt="Attachment" style={{ width: "100%", height: "90vh", objectFit: "contain" }} />
                        ) : preview?.data?.name?.endsWith('.pdf') ? (
                            <div>
                                <object type="text/html" data={`https://sparta-aims.ams3.digitaloceanspaces.com/others/tools/pdf.js/web/viewer.html?file=${encodeURIComponent(preview?.data?.file)}`} style={{ width: '100%', height: window.innerHeight - 100 }}>
                                    <param name="type" value="text/html" />
                                </object>
                            </div>) : (
                            <p>Preview not available for this file type</p>
                        )}

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => onDownloadAttachment(preview.data)} download={preview.data.name} variant="outlined" size="small" color="primary">Download</Button>
                        <Button onClick={()=>setPreview({modal:false,data:null})} variant="outlined" size="small" color="primary">Close</Button>
                    </DialogActions>
                </Dialog>
            )}
        </div>
    )
}
export default withRouter(Attachment);